export default __webpack_public_path__ + "static/media/Astellas.458ce2b6.svg";